import React from 'react';

import K from 'k';

const Loader = () => {
  const styles = {
    loader: {
      border: '0.25rem solid',
      borderTop: `0.25rem solid ${K.colors.gray}`,
      borderLeft: '0.25rem solid linear-gradient(to right, black, #00000025)',
      borderRight: '0.25rem solid linear-gradient(to right, #00000025, #00000050)',
      borderBottom: '0.25rem solid linear-gradient(to right, #00000050, #00000075)',
      borderRadius: '50%',
      width: '2rem',
      height: '2rem',
      animation: 'spin 1s linear infinite',
    }
  };

  return (
    // <div style={{position: 'fixed', height: '100%', width: '100%', zIndex: Number.MAX_SAFE_INTEGER, backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
    //   <div style={{width: '60%', position: 'relative', left: '20%', top: '30%', backgroundColor: '#d1d5db', borderRadius: '9999px', height: '0.5rem', alignSelf: 'center', overflow: 'hidden'}}>
    //     <div style={{backgroundColor: '#3b82f6', borderRadius: '9999px', position: 'absolute', bottom: 0, top: 0, width: '50%',
    //       height: '0.5rem', animationDuration: '2s', animationIterationCount: 'infinite', animationName: 'indeterminate-progress-bar'
    //     }}/>
    //   </div>
    // </div>
    <div style={styles.loader}/>
  );
};

export default Loader;
